<template>
  <div class="create px-12 py-8">
    <lCrumbs :breadcrumb="breadcrumbItems" />
    <div>
      <div
        class="text-center md:text-left mb-8 text-2xl font-bold page-heading"
      >
        Edit Learner
      </div>
      <div class="md:flex w-full">
        <div class="w-full md:w-1/2">
          <div class="md:mx-12">
            <div class="item md:flex md:items-center w-full mb-12">
              <div class="w-full md:w-1/4 mr-4">
                <label class="text-black font-bold" for="">First Name: </label>
              </div>
              <div class="w-full">
                <linput
                  type="text"
                  name="first_name"
                  v-model="form.first_name"
                  :errorMessage="errors.first_name"
                  :error="errors.first_name"
                  placeholder="First Name"
                />
              </div>
            </div>
            <div class="item md:flex md:items-center w-full mb-12">
              <div class="w-full md:w-1/4 mr-4">
                <label class="text-black font-bold" for="">Last Name: </label>
              </div>
              <div class="w-full">
                <linput
                  type="text"
                  name="lname"
                  v-model="form.last_name"
                  :errorMessage="errors.last_name"
                  :error="errors.last_name"
                  placeholder="Last Name"
                />
              </div>
            </div>
            <div class="item md:flex md:items-center w-full mb-12">
              <div class="w-full md:w-1/4 mr-4">
                <label class="text-black font-bold" for="">Email: </label>
              </div>
              <div class="w-full">
                <linput
                  type="email"
                  name="email"
                  v-model="form.email"
                  :errorMessage="errors.email"
                  :error="errors.email"
                  placeholder="Email Address"
                />
              </div>
            </div>
            <div class="item md:flex md:items-center w-full mb-12">
              <div class="w-full md:w-1/4 mr-4">
                <label class="text-black font-bold" for="">Phone: </label>
              </div>
              <div class="w-full">
                <linput
                  type="text"
                  name="phone"
                  v-model="form.phone_number"
                  :errorMessage="errors.phone_number"
                  :error="errors.phone_number"
                  placeholder="Phone Number"
                />
              </div>
            </div>
            <div class="item md:flex md:items-center w-full mb-12">
              <div class="w-full md:w-1/4 mb-2 md:mb-0 mr-4">
                <label class="text-black font-bold" for="">Gender: </label>
              </div>
              <div class="w-full">
                <div>
                  <input
                    type="radio"
                    name="course-landing"
                    v-model="form.gender"
                    value="male"
                  />
                  Male
                  <input
                    type="radio"
                    name="course-landing"
                    v-model="form.gender"
                    value="female"
                  />
                  Female
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/2">
          <div class="md:mx-12">
            <div class="item md:flex md:items-center w-full mb-12">
              <div class="w-full md:w-1/4 mr-4">
                <label class="text-black font-bold" for=""
                  >Learner Image:
                </label>
              </div>
              <div class="">
                <vue-dropzone
                  @vdropzone-drag-drop="form.student_image = $event"
                  @vdropzone-file-added="form.student_image = $event"
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                ></vue-dropzone>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div>
          <lbutton
            class="mb-12"
            @click="editLearner"
            :color="`#0B85E4`"
            textColor="#fff"
            >Edit Learner
          </lbutton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import FormActions from "@/mixins/FormActions";
export default {
  mixins: [FormActions],
  data() {
    return {
      form: {},
      errors: {},
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/users/",
          text: "All Learners",
        },
        {
          disabled: true,
          to: "#",
          text: "Edit Learner",
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["tenantUpdateUser", "tenantGetLearner"]),
    async editLearner() {
      this.errors = [];
      this.updateLoader(true);
      if (this.form.student_image) {
        this.form.student_image = await this.uploadFile(
          this.form.student_image
        );
      } else {
        this.form.student_image = "";
      }
      let res = await this.tenantUpdateUser({
        data: this.form,
        id: this.$route.params.id,
      });
      this.updateLoader(false);
      if (res.status == 200) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Learner updated successfully",
        });
        this.$router.push({
          name: "tenant-users-home",
        });
      } else {
        this.errors = res.data.errors[0].source;
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
  },
  components: {
    linput: () => import("@/components/general/input"),
    lbutton: () => import("@/components/general/button"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
  },
  async created() {
    this.updateLoader(true);
    let res = await this.tenantGetLearner({
      id: this.$route.params.id,
    });
    this.form = res.data.data.learner;
    this.updateLoader(false);
  },
};
</script>
<style lang="scss" scoped>
.dropzone {
  min-height: 8px;
  padding: 4px 10px;
  border-style: dotted solid;
}
</style>
